// Core packages
import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

// Third party packages
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormlyFieldConfig, FormlyFormOptions } from '@ngx-formly/core';
import { TranslateService } from '@ngx-translate/core';
import { MatProgressButtonOptions } from 'mat-progress-buttons';
import { CookieService } from 'ngx-cookie-service';
import { Subscription } from "rxjs";

// Custom packages
import { PropertiesService } from "src/app/modules/properties/properties.service";
import { ConfigService } from 'src/app/shared/services/config.service';
import { HelperService } from "src/app/shared/services/helper.service";

@Component({
  selector: 'app-export-cd-docs-dialog',
  templateUrl: './export-cd-docs-dialog.component.html',
  styleUrls: ['./export-cd-docs-dialog.component.scss']
})
export class ExportCdDocsDialogComponent implements OnInit {
  lang = this.translateService.currentLang || this.translateService.defaultLang;

  private subscriptions: Subscription[] = [];

  // BEGIN - Add subUser form
  // BEGIN - ngx-formly
  form: FormGroup = new FormGroup({});
  model: any = {};
  fields: FormlyFieldConfig[] = [];
  options: FormlyFormOptions = {};
  // END - ngx-formly

  formBtnOptions: MatProgressButtonOptions = {
    active: false,
    text: this.translateService.instant('common.cta.send'),
    spinnerSize: 19,
    raised: true,
    stroked: true,
    flat: false,
    fab: false,
    buttonColor: 'primary',
    spinnerColor: 'primary',
    fullWidth: false,
    disabled: false,
    mode: 'indeterminate',
    buttonIcon: {
      fontSet: 'fal',
      fontIcon: 'fa-paper-plane',
      inline: true,
    },
  };
  // END - Add communication form

  dialogIsLoading = true;

  /**
   * Class constructor
   */
  constructor(
    public dialogRef: MatDialogRef<ExportCdDocsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public configService: ConfigService,

    private cookieService: CookieService,
    private translateService: TranslateService,
    private propertiesService: PropertiesService,
    private helperService: HelperService,
  ) { }

  /**
   * Init component
   *
   */
  ngOnInit(): void {
    // Get current lang
    this.lang = this.cookieService.get('lang') || this.configService.defaultLang;

    this.onExportFile(this.data.propertyId, this.data.propertyName);

  }

  
  /**
   * CD Export file
   * export the files of all condominium documents in zip format
   *
   * @since 1.0.0
   */
  onExportFile(propertyId?: string, propertyName?: string): void {
    this.subscriptions.push(
      this.propertiesService.getFileExport(propertyId).subscribe(
        (res) => {
          const fileBlob = res;
          this.dialogIsLoading = false;
          if (fileBlob.status) {
            const documents: any[] = [];
            if (fileBlob.listZipFiles && Array.isArray(fileBlob.listZipFiles)) {
              for(const file of fileBlob.listZipFiles) {
                documents.push({
                  filename: file.fileName,
                  originalName: file.fileName,
                  path: file.pathFileName,
                  size: file.fileSize,
                  mimetype: fileBlob.fileMimeType,
                });
              }
            }
            this.model = {
              documents: documents,
            }
            this.initForm();
          }
        },
        (err) => {
          this.dialogIsLoading = false;
          this.helperService.handleError(err);
        }
      )
    );
  }

  /**
   * Init form
   *
   * @since 1.0.0
   */
  initForm(): void {
    // Set fields
    this.fields = [
      {
        fieldGroupClassName: 'row',
        fieldGroup: [
          {
            className: "col-12 mb-0",
            type: "file-downloader",
            key: "documents",
            hideExpression: (model): boolean => !model || model.length === 0,
            templateOptions: {
              label: this.translateService.instant('properties.fields.documents'),
              required: false,
              bindLabel: "originalName",
              readonly: true,
            }
          },
        ],
      },
    ];
  }

  /**
   * Handle dialog closing
   *
   * @since 1.0.0
   *
   */
  onClose(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
    
    this.dialogRef.close();
  }
}
